import { IReportingTypeService } from "../../service/reporting/ReportingTypeService";

export default class GetReportingTypesInteractor {
  private reportingTypeService: IReportingTypeService;

  constructor(reportingTypeService) {
    this.reportingTypeService = reportingTypeService;
  }

  async execute() {
    return this.reportingTypeService.getReportingTypes();
  }
}
